import eventRegistration from './eventRegistration/main'
import iFrame from './iFrame/main'
import menu from './menu'
import error from './error'
import cardSelect from './cardSelect'
import core from "./core";
import registrationOverview from "./registrationOverview";
import de from '@vee-validate/i18n/dist/locale/de.json';

export default {
    eventRegistration,
    menu,
    error,
    cardSelect,
    iFrame,
    registrationOverview,
    core,

    yes: "Ja",
    no: "Nein",

    on: "An",
    off: "Aus",

    day: "Tag",
    month: "Monat",
    year: "Jahr",

    validations: {
        ...de.messages,
        min_value: "{field} muss mindestens {'0:{min}'} sein",
        between: "{field} muss zwischen {'0:{min}'} und {'1:{max}'} liegen",
        dimensions: "{field} muss {'0:{width}'} x {'1:{height}'} Bildpunkte groß sein",
        length: "Die Länge von {field} muss {'0:{length}'} sein",
        max: "{field} darf nicht länger als {'0:{length}'} Zeichen sein",
        max_value: "{field} darf maximal {'0:{max}'} sein",
        min: "{field} muss mindestens {'0:{length}'} Zeichen lang sein",
        size: "{field} muss kleiner als {'0:{size}'} KB sein",
        verify_password: "Das Passwort ist zu schwach. Bitte wähle ein stärkeres Passwort",
        confirm_password: "Das Passwort stimmt nicht überein",
        verify_url: "URL ist ungültig",
        validation_pending: "Wird geprüft...",
        address_is_incomplete: "Adresse ist unvollständig",
        isInvalid: "{field} ist ungültig",
        addressIsIncomplete: "Adresse ist unvollständig",
        minAgeInvoice: "Der/Die Rechnungsempfänger/in muss mindestens {minAge} Jahre alt sein. Bitte frage am besten Dein Sorgeberichtigten oder Vormund, ob dieser sich als Rechnungsempfänger/in eintragen kann.",
        minAgeContactPerson: "Die Ansprechperson muss mindestens {minAge} Jahre alt sein. Bitte frage am besten Deinen Sorgeberichtigten oder Vormund, ob dieser sich als Ansprechperson eintragen kann.",
        minAgeEventParticipant: "Sie sind leider zum Zeitpunkt der Veranstaltung zu jung für das Angebot. Das Mindestalter beträgt {minAge} Jahre.",
        maxAgeEventParticipant: "Sie sind leider zum Zeitpunkt der Veranstaltung zu alt für das Angebot. Das Höchstalter beträgt {maxAge} Jahre.",
        tooManyFemales: "Leider sind zwischenzeitlich Plätze für weibliche Teilnehmer vergeben worden. Bitte reduzieren Sie ihre weiblichen Teilnehmer um {value}, um fortfahren zu können.",
        tooManyMales: "Leider sind zwischenzeitlich Plätze für männliche Teilnehmer vergeben worden. Bitte reduzieren Sie ihre männlichen Teilnehmer um {value}, um fortfahren zu können.",
        tooManyParticipants: "Leider sind zwischenzeitlich Plätze vergeben worden. Bitte reduzieren Sie ihre Teilnehmerzahl um {value}, um fortfahren zu können.",
        participantsRequired: "Mindestens ein Teilnehmer wird benötigt",
        personsRequired: "Mindestens eine Person wird benötigt",
        caregiversRequired: "Mindestens ein Betreuer wird benötigt",
        phone: "Das Format der Telefonnummer ist nicht gültig. Es sind nur Zahlen, sowie das Zeichen + erlaubt. Eine gültige Nummer wäre bspw.: +49 711 XXXXXX.",
        phoneInvalid: "Das Format der Telefonnummer ist nicht gültig. Es sind nur Zahlen, sowie das Zeichen + erlaubt. Eine gültige Nummer wäre bspw.: +49 711 XXXXXX.",
        ibanInvalid: "Ihre IBAN ist ungültig. Bitte überprüfen Sie Ihre eingebene IBAN.",
        juleicaInvalid: "{value} ist keine gültige Juleica-Kartennummer oder ist bereits abgelaufen.",
        juleicaCardNumberDoesntMatchWithContact: "{value} ist eine gültige Kartennummer, passt aber nicht zu den Daten des Kontakts.",
        dateIsInvalid: "Das eingegebene Datum ist nicht gültig.",
        invoiceRecipient: "Bitte geben Sie einen Rechnungsempfänger an.",
        contactPerson: "Bitte geben Sie eine Ansprechperson an.",
        includes: "Die Eingabe muss {text} enthalten.",
        correctAge: "Bitte geben Sie ein korrektes Geburtsdatum ein.",
        correctDateFormat: "Bitte geben Sie ein vollständiges Datum ein.",
        pending: "Wird geprüft...",
        dateInValidRange: "Ungültiges Datum.",
        validDate: "Der eingegebene Wert ist kein gültiges Datum.",
        dateIsAfter: "Das eingegebene Datum ist nicht gültig.",
        dateIsBefore: "Das eingegebene Datum ist nicht gültig."
    }
}
